var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBoxData(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "420.000000pt",
    height: "451.000000pt",
    viewBox: "0 0 420.000000 451.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,451.000000) scale(0.100000,-0.100000)",
    fill: "green",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M245 1643 c-56 -29 -95 -75 -111 -130 -13 -45 -15 -116 -12 -455 4 -389 5 -405 27 -472 35 -105 77 -174 155 -251 81 -80 159 -125 267 -155 75 -20 85 -20 1550 -18 l1474 3 62 22 c154 56 277 163 343 297 69 140 70 152 70 606 l0 406 -25 51 c-37 73 -89 106 -174 111 -79 4 -136 -21 -185 -82 l-31 -38 -5 -411 c-4 -359 -7 -416 -22 -442 -24 -44 -70 -84 -109 -95 -21 -6 -548 -10 -1432 -10 -1376 0 -1398 0 -1437 20 -21 11 -51 36 -67 57 l-28 36 -5 406 c-4 271 -9 414 -17 432 -19 44 -66 91 -108 110 -49 23 -139 24 -180 2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxData);
export default __webpack_public_path__ + "static/media/box-data.435dad5d2ad99a92f73753f8c48de509.svg";
export { ForwardRef as ReactComponent };